import React from 'react';

/**
 * Reserved AdSense slot placeholder. Renders a clearly-labeled dashed box
 * with a fixed minimum height so real ads (when added) do not cause layout shift.
 * The placeholder is visually SUBORDINATE to main content and never sits next
 * to interactive buttons or inputs.
 */
export function AdSlot({ size = 'leaderboard', className = '', id }) {
  const sizes = {
    leaderboard: 'min-h-[90px]',
    rectangle: 'min-h-[250px]',
    sidebar: 'min-h-[600px]',
  };
  return (
    <aside
      role="complementary"
      aria-label="Advertisement placeholder"
      data-testid={id || `ad-slot-${size}`}
      className={`w-full ${sizes[size]} flex items-center justify-center bg-slate-50 border-2 border-dashed border-slate-200 rounded-xl text-slate-400 text-xs sm:text-sm font-medium tracking-wide ${className}`}
    >
      <span className="uppercase">Advertisement slot</span>
    </aside>
  );
}
